<app-layout>
    <!-- <app-breadcrumb></app-breadcrumb> -->
  
    <div class="tables-wrapper">
      <app-branch-table [branchTableData]="branchTableData$ | async"></app-branch-table>
    </div>
  
    <!-- <app-footer></app-footer> -->
  </app-layout>
  